import React from 'react';

export default function FormHeader() {
  return (
    <div className="bg-white border-b p-4 mb-6 shadow-sm">
      <h1 className="text-2xl font-bold text-gray-800">Formulário de Engenharia Solar</h1>
      <p className="text-sm text-gray-500">Preencha os dados do projeto para análise</p>
    </div>
  );
}
